var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{ref:"modal",attrs:{"id":`modal-preview-${_vm.parentComponent.modalItemName}`,"title":_vm.$t('details'),"size":"xl","hide-footer":"","scrollable":""}},[(_vm.item)?[_c('JsonViewer',{attrs:{"value":_vm.item,"expand-depth":2}})]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }